import React from "react";
import PropTypes from "prop-types";
import styles from "./ArchiveConfirmationModal.module.css";
import { Modal } from "shared/Modal";
import classNames from "classnames";

/**
 * Modal that opens when the user clicks the archive button.
 */

export function ArchiveConfirmationModal({
  isOpen,
  onCollapse,
  onClick,
  email,
  isArchived,
}) {
  return (
    <div className={styles.container}>
      <Modal
        title={
          isArchived
            ? "UNARCHIVE EMAIL CONFIRMATION"
            : "ARCHIVE EMAIL CONFIRMATION"
        }
        isOpen={isOpen}
        onClose={onCollapse}
        className={styles.modal}
        children={
          <>
            <div>{`Are you sure you want to ${
              isArchived ? "unarchive" : "archive"
            } this email: ${email}?`}</div>

            <div>
              <button
                className={classNames(
                  styles.button,
                  isArchived ? styles.unarchiveBtn : styles.archiveBtn
                )}
                onClick={onClick}
              >
                {isArchived ? "UNARCHIVE" : "ARCHIVE"}
              </button>
              <button className={styles.button} onClick={onCollapse}>
                CANCEL
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

ArchiveConfirmationModal.propTypes = {
  /**
   * Determines if the modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Function called when cancel is clicked
   */
  onCollapse: PropTypes.func,
  /**
   * Function called when refund is clicked
   */
  onClick: PropTypes.func,
  email: PropTypes.string,
  isArchived: PropTypes.bool,
};
